import React from "react";
import {Button} from "react-bootstrap";
import ChangeLogList from "./tc-changed/change-log-list.jsx";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from "immutable";

export default class TCChanged extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            changeLogs: [],
            total: 0,
            isAllSelected: false,
            withSelection: false
        }

        this.load = this.load.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onTcItemChecked = this.onTcItemChecked.bind(this);
        this.onToggleNotes = this.onToggleNotes.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    componentDidMount() {
        context.message({
            show: true,
            type: "loading",
            message: "Loading. Please wait..."
        });

        let clone = immutable.fromJS(this.state).toJS();
        clone.page = 0;
        clone.pageSize = 10;
        this.setState(clone, this.load);
    }

    onToggleNotes(idx) {
        let map = immutable.fromJS(this.state);
        let clone = map.toJS();
        if (clone.changeLogs[idx].showNotes != null)
            clone.changeLogs[idx].showNotes =  !clone.changeLogs[idx].showNotes;
        else
            clone.changeLogs[idx].showNotes = true;

        this.setState(clone);
    }

    onNavigate(page) {
        let clone = immutable.fromJS(this.state).toJS();
        clone.page = page;
        this.setState(clone, this.load);
    }
    
    onTcItemChecked(idx) {
        let map = immutable.fromJS(this.state);
        let clone = map.toJS();
        clone.withSelection = false;
        if (idx === "all") {
            clone.isAllSelected = !clone.isAllSelected;
            for(let i=0; i<clone.changeLogs.length; i++) {
                let tc = clone.changeLogs[i];
                tc.isChecked = clone.isAllSelected;
            }
            clone.withSelection = clone.isAllSelected;
        } else {
            clone.changeLogs[idx].isChecked = clone.changeLogs[idx].isChecked || false;
            clone.changeLogs[idx].isChecked = !clone.changeLogs[idx].isChecked;
            clone.isAllSelected = false;

            if (clone.changeLogs[idx].isChecked) {
                clone.withSelection = true;
            } else {
                for(let i=0; i<clone.changeLogs.length; i++) {
                    if (clone.changeLogs[i].isChecked) {
                        clone.withSelection = true;
                        break;
                    }
                }
            }
        }
        
        this.setState(clone);
    }

    onConfirm() {
        let clone = this.state;
        context.message({
                    show: true,
                    type: "loading",
                    message: "Processing. Please wait...",
                });
        let self = this;        
        let selectedIds = [];
        for(let i=0; i<clone.changeLogs.length; i++) {
            if (clone.changeLogs[i].isChecked) {
                selectedIds.push(clone.changeLogs[i].id);
            }
        }

        ajax.api()
            .put("confirm-timecard-changes/people", {id: selectedIds})
            .then(function(res) {
                self.load();
                context.message({show:false});
            })
            .catch(function(err) {       
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show :true,
                    type : "error",
                    message: <div>Error when attempting to confirm timecard changes.<br/>{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    load() {
        let self = this;                
        let vm = self.state;        
        context.message({show:true, type: "loading", message:"Loading. Please wait..."});
        ajax.api().get("get-unconfirmed-tc-changes/people", {
            params : {
                p: vm.page,
                pz: vm.pageSize
            }
        })
        .then(function(res) {
            self.setState({changeLogs: res.data.rows, total: res.data.totalRow, isAllSelected: false, withSelection: false});
            context.message({show:false});
        })
        .catch(function(err) {
            let data = err.response.data;
            context.message({
                show: true,
                type: "error",
                message: data.exceptionMessage || data.message,
                buttons: "close"
            });
        });
    }

    render() {
        const self = this;
        console.log(self.state);
        let idx = 0;
        let idx2 = 0;
        return (
            <div className="ap-form-container">
                <div className="container">
                    <div className="row hidden-sm hidden-xs">
                        <div className="col-md-12">
                            <h2 className="text-center ap-title">Time Change Acknowledgment</h2>
                            <h3 className="text-center ap-sub-title">These timecards have been edited by your supervisor.</h3>
                            <h4 className="text-center">
                                    * To review the edits made by the supervisor, click the timecard.<br/>
                                    * To agree with the edits, click the CONFIRM button.<br/></h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <ChangeLogList vm={self.state} onNavigate={this.onNavigate} onTcItemChecked={this.onTcItemChecked} onToggleNotes={this.onToggleNotes} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Button className={this.state.withSelection? "ap-fullsize btn-info": "ap-fullsize"} onClick={() => this.onConfirm()}
                                disabled={this.state.withSelection? false: true}>Confirm</Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}